import { render, staticRenderFns } from "./LayoutTopComponent.vue?vue&type=template&id=13aef608&scoped=true&"
import script from "./LayoutTopComponent.vue?vue&type=script&lang=js&"
export * from "./LayoutTopComponent.vue?vue&type=script&lang=js&"
import style0 from "./LayoutTopComponent.vue?vue&type=style&index=0&id=13aef608&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aef608",
  null
  
)

export default component.exports